export default __webpack_public_path__ + "static/media/fsiRealCase2.836503b8.jpg";